<template>

    <div class="vld-parent">

        <loading :active="componentLoading" :is-full-page="false" :can-cancel="true"></loading>

        <!-- BEGIN SECTION CONTENT -->
        <div class="category-section-container py-5 px-4 bg-theme-level3 text-theme-main">

            <!--v-for="(contentPiece, index) in contentPayload" v-if="(contentPiece.render_size === 'Pequeño' || contentPiece.render_size === 'Small')"-->
            <content-module-small
                v-for="(contentPiece, index) in contentPayload"
                v-bind:key="contentPiece.id"
                :content="contentPiece"
                :currentlocale="currentlocale"
                :legacy="contentPiece.legacy"
                :default_thumbnail="default_thumbnail"
            ></content-module-small>
            <!-- END SECTION CONTENT -->


        </div>

        <infinite-loading @distance=10 @infinite="infiniteHandlerDown">
            <template slot="no-more">&nbsp;</template>
        </infinite-loading>

        <div v-if="noMoreContent">
            <p class="text-base text-theme-discrete ml-6 mb-8 mr-6">{{ translate('page-no-more') }}</p>
        </div>

    </div>

</template>

<script>

import { isMobileOnly } from 'mobile-device-detect';
import { isTablet } from 'mobile-device-detect';

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

const Lang = require('lang.js');
import translations from './messages.js';

const lang = new Lang();

lang.setMessages(translations);

export default {

    components: {
        Loading
    },

    data() {
        return {
            componentLoading: true,
            contentPayload: [],
            currentPage: '',
            lastPage: '',

            pageToLoad: 1,

            smartphone: isMobileOnly,
            tabletDevice: isTablet,

            itemsPerPage: 12,

            isFirstRun: true,
            noMoreContent: false,
            itemKey: 0
        }
    },

    props: [
        'currentlocale',
        'category_id',
        'sub_category_id',
        'default_thumbnail',
    ],

    computed: {



    },

    methods: {

        infiniteHandlerUp($state) {
            if (!this.isFirstRun) {
                alert('Infinite Handler Up was called!')
                $state.loaded()
            }
        },

        infiniteHandlerDown($state) {

            // alert('Infinite Loading triggered - state = ' + JSON.stringify(state))

            console.log('Infinite Handler is calling: ' + '/api/explore/' + this.category_id + '/' + this.sub_category_id + '/' + this.currentlocale + '/' + this.itemsPerPage + '/' + this.pageToLoad)

            this.componentLoading = true

            if(this.isFirstRun) {
                axios.get('/api/explore/' + this.category_id + '/' + this.sub_category_id + '/' + this.currentlocale + '/' + this.itemsPerPage + '/' + this.pageToLoad)
                    .then(response => {
                        this.componentLoading = false
                        this.currentPage = response.data.current_page
                        this.lastPage = response.data.last_page
                        if (response.data.data.length) {
                            this.contentPayload = response.data.data
                            this.pageToLoad += 1
                            $state.loaded()
                            this.isFirstRun = false
                        } else {
                            $state.complete()
                        }
                    })
                    .catch(error => {
                        console.log('SERVER ERROR GETTING FILTERED CONTENT!! --> ' + JSON.stringify(error));
                    });
            } else {
                axios.get('/api/explore/' + this.category_id + '/' + this.sub_category_id + '/' + this.currentlocale + '/' + this.itemsPerPage + '/' + this.pageToLoad)
                    .then(response => {
                        this.componentLoading = false
                        this.currentPage = response.data.current_page
                        this.lastPage = response.data.last_page
                        if (response.data.data.length) {
                            console.log('We got a response from the backend...')
                            let resultingData = {}
                            let key;

                            for (key in this.contentPayload) {
                                if(this.contentPayload.hasOwnProperty(key)){
                                    resultingData[this.itemKey] = this.contentPayload[key];
                                    this.itemKey += 1
                                    console.log('Content Payload Key: ' + this.itemKey)
                                }
                            }

                            for (key in response.data.data) {
                                if(response.data.data.hasOwnProperty(key)){
                                    resultingData[this.itemKey] = response.data.data[key];
                                    this.itemKey += 1
                                    console.log('Response Data Key: ' + this.itemKey)
                                }
                            }

                            this.contentPayload = resultingData
                            this.pageToLoad += 1
                            $state.loaded()
                        } else {
                            $state.complete()
                            this.noMoreContent = true
                        }
                    })
                    .catch(error => {
                        console.log('SERVER ERROR GETTING FILTERED CONTENT!! --> ' + JSON.stringify(error));
                    });
            }

            /*axios.get(api, {
                params: {
                    page: this.page,
                },
            }).then(({ data }) => {
                if (data.hits.length) {
                    this.page += 1;
                    this.list.push(...data.hits);
                    $state.loaded();
                } else {
                    $state.complete();
                }
            });*/
        },

        translate(key) {
            key = 'strings.' + key;
            return lang.get(key);
        },

        getPreviousPage() {

            this.componentLoading = true;

            if(this.currentPage > 1) {

                axios.get('/api/explore/' + this.category_id + '/' + this.sub_category_id + '/' + this.currentlocale + '/' + this.itemsPerPage + '/' + (this.currentPage - 1))
                    .then(response => {
                        this.componentLoading = false;
                        this.contentPayload = response.data.data;
                        this.currentPage = response.data.current_page;
                    })
                    .catch(error => {
                        console.log('SERVER ERROR GETTING FILTERED CONTENT!! --> ' + JSON.stringify(error));
                    });
            }

        },

        getNextPage() {

            this.componentLoading = true;

            if(this.currentPage < this.lastPage ) {

                axios.get('/api/explore/' + this.category_id + '/' + this.sub_category_id + '/' + this.currentlocale + '/' + this.itemsPerPage + '/' + (this.currentPage + 1))
                    .then(response => {
                        this.componentLoading = false;
                        this.contentPayload = response.data.data;
                        this.currentPage = response.data.current_page;
                    })
                    .catch(error => {
                        console.log('SERVER ERROR GETTING FILTERED CONTENT!! --> ' + JSON.stringify(error));
                    });

            }

            this.scrollToEnd();

        },

        scrollToEnd: function() {
            if(this.smartphone) {
                let element = document.getElementById("sectionTop" + this.index);
                element.scrollIntoView({behavior: "smooth"});
            }
        },

    },

    created() {

        this.itemsPerPage = (Math.round(((window.innerWidth - 224) / 255)) * Math.round(((window.innerHeight - 150) / 285))) + Math.round(((window.innerWidth - 224) / 255))
        console.log('Items per page with extras: ' + this.itemsPerPage)

        /*axios.get('/api/explore/' + this.sub_category_id + '/' + this.currentlocale + '/' + this.itemsPerPage)
            .then(response => {
                this.componentLoading = false;
                this.contentPayload = response.data.data;
                this.currentPage = response.data.current_page;
                this.lastPage = response.data.last_page;
            })
            .catch(error => {
                console.log('SERVER ERROR GETTING FILTERED CONTENT!! --> ' + JSON.stringify(error));
            });
*/
    },

}

</script>


<style scoped>

:root {
    --spacing: 100px;
}

.category-section-container {

    display: grid;
    grid-gap: 35px;
    grid-template-columns: repeat(auto-fill, minmax(215px, 1fr));
    grid-template-rows: 280px;
    grid-auto-rows: 280px;
}

/*.section-container {
    overflow-y: scroll;
}*/

.hs > li,
.item {
    scroll-snap-align: center;
    padding: calc(var(--gutter) / 2 * 1.5);
    /*margin-top: 10px;
    margin-bottom: 10px;*/
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #fff;
    border-radius: 8px;
}

</style>
